// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sales-page {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  color: white;
}

.page-header h1 {
  margin: 0;
  font-size: 2rem;
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Statistics Cards */
.sales-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

/* Stat cards use .stat-card from design-system.css */
/* Only minor adjustments needed */
.stat-card h3 {
  margin: 0 0 10px 0;
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.stat-value {
  font-size: 2rem;
  font-weight: bold;
  margin: 0;
}

/* Sale Form - Uses glass-panel from design-system.css */
.sale-form {
  /* Inherits from .glass-panel via class in JSX */
  padding: 25px;
  margin-bottom: 30px;
}

.sale-form h2 {
  margin-top: 0;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #ffffff;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 10px 15px;
  background: rgba(15, 23, 42, 0.6);
  color: var(--white);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 5px;
  font-size: 1rem;
  transition: border-color 0.3s;
}

.form-group input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}

/* Sales Table - Uses glass-panel from design-system.css */
.sales-table-container {
  /* Inherits from .glass-panel via class in JSX */
  overflow: hidden;
}

.sales-table {
  width: 100%;
  border-collapse: collapse;
}

.sales-table thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.sales-table th {
  padding: 15px;
  text-align: left;
  font-weight: 600;
}

.sales-table tbody tr {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  transition: background-color 0.3s;
}

.sales-table tbody tr:hover {
  background-color: rgba(99, 102, 241, 0.1);
}

.sales-table td {
  padding: 15px;
  color: #ffffff;
}

.sales-table .amount {
  font-weight: 600;
  color: #818cf8;
  font-size: 1.1rem;
}

.sales-table .actions {
  display: flex;
  gap: 10px;
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: #ffffff;
  font-style: italic;
}

/* Buttons */
.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-success {
  background: #10b981;
  color: white;
}

.btn-success:hover {
  background: #059669;
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.btn-icon {
  padding: 8px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background: transparent;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.btn-icon.edit {
  color: #f59e0b;
}

.btn-icon.edit:hover {
  background: rgba(245, 158, 11, 0.15);
  transform: scale(1.1);
}

.btn-icon.delete {
  color: #ef4444;
}

.btn-icon.delete:hover {
  background: rgba(239, 68, 68, 0.15);
  transform: scale(1.1);
}

/* Loading */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.loader {
  width: 48px;
  height: 48px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive */
@media (max-width: 768px) {
  .sales-stats {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .page-header {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }

  .sales-table {
    font-size: 0.9rem;
  }

  .sales-table th,
  .sales-table td {
    padding: 10px;
  }
}

/* Payment Type Selector */
.payment-type-selector {
  display: flex;
  gap: 20px;
  margin-top: 10px;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 15px;
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  color: #ffffff;
}

.radio-label:hover {
  border-color: #818cf8;
  background-color: rgba(99, 102, 241, 0.1);
}

.radio-label input[type='radio'] {
  margin: 0;
}

.radio-label input[type='radio']:checked + span {
  font-weight: 600;
  color: #818cf8;
}

.radio-label:has(input:checked) {
  border-color: #818cf8;
  background-color: rgba(99, 102, 241, 0.2);
}

.payment-type {
  text-align: center;
  font-size: 1.2rem;
}

/* Month Selector - Uses glass-panel */
.month-selector-container {
  /* Inherits from .glass-panel via class in JSX */
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.month-selector-container label {
  font-weight: 600;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1rem;
}

.month-selector {
  flex: 1 1;
  max-width: 300px;
  padding: 12px 15px;
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  font-size: 1rem;
  background: rgba(15, 23, 42, 0.6);
  cursor: pointer;
  transition: all 0.3s;
  color: var(--white);
  font-weight: 500;
}

.month-selector:hover {
  border-color: var(--primary-color);
  background-color: rgba(99, 102, 241, 0.1);
}

.month-selector:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}

/* Highlighted Stat Card */
.stat-card.highlight {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: 3px solid #667eea;
}

.stat-card.highlight h3 {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
}

.stat-card.highlight .stat-value {
  color: white;
  font-size: 2.5rem;
}

.stat-card.highlight small {
  color: rgba(255, 255, 255, 0.8);
  display: block;
  margin-top: 8px;
  font-size: 0.9rem;
}

.stat-card small {
  display: block;
  margin-top: 8px;
  color: rgba(226, 232, 240, 0.75);
  font-size: 0.85rem;
}

/* ============ LIGHT THEME OVERRIDES ============ */
[data-theme="light"] .form-group label {
  color: #1e293b;
}

[data-theme="light"] .form-group input {
  background: rgba(255, 255, 255, 0.9);
  color: #1e293b;
  border: 1px solid rgba(15, 23, 42, 0.15);
}

[data-theme="light"] .form-group input:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);
}

[data-theme="light"] .sales-table tbody tr {
  border-bottom: 1px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .sales-table tbody tr:hover {
  background-color: rgba(100, 116, 139, 0.08);
}

[data-theme="light"] .sales-table td {
  color: #1e293b;
}

[data-theme="light"] .sales-table .amount {
  color: #475569;
}

[data-theme="light"] .empty-state {
  color: #475569;
}

[data-theme="light"] .btn-secondary {
  background: rgba(100, 116, 139, 0.08);
  color: #1e293b;
  border: 1px solid rgba(100, 116, 139, 0.2);
}

[data-theme="light"] .btn-secondary:hover {
  background: rgba(100, 116, 139, 0.12);
  border-color: rgba(100, 116, 139, 0.3);
}

[data-theme="light"] .radio-label {
  border: 2px solid rgba(15, 23, 42, 0.15);
  color: #1e293b;
}

[data-theme="light"] .radio-label:hover {
  border-color: #64748b;
  background-color: rgba(100, 116, 139, 0.08);
}

[data-theme="light"] .radio-label input[type='radio']:checked + span {
  color: #475569;
}

[data-theme="light"] .radio-label:has(input:checked) {
  border-color: #64748b;
  background-color: rgba(100, 116, 139, 0.15);
}

[data-theme="light"] .month-selector-container label {
  color: #1e293b;
}

[data-theme="light"] .month-selector {
  border: 2px solid rgba(15, 23, 42, 0.15);
  background: rgba(255, 255, 255, 0.9);
  color: #1e293b;
}

[data-theme="light"] .month-selector:hover {
  border-color: var(--primary-color);
  background-color: rgba(100, 116, 139, 0.08);
}

[data-theme="light"] .month-selector:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);
}

[data-theme="light"] .stat-card small {
  color: #64748b;
}

[data-theme="light"] .stat-card h3 {
  color: #475569;
}
`, "",{"version":3,"sources":["webpack://./src/features/sales/Sales.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD,kCAAkC;AAClC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA,wDAAwD;AACxD;EACE,gDAAgD;EAChD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,gDAAgD;EAChD,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA,0BAA0B;AAC1B;EACE,6DAA6D;EAC7D,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".sales-page {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding: 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 10px;\n  color: white;\n}\n\n.page-header h1 {\n  margin: 0;\n  font-size: 2rem;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* Statistics Cards */\n.sales-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n/* Stat cards use .stat-card from design-system.css */\n/* Only minor adjustments needed */\n.stat-card h3 {\n  margin: 0 0 10px 0;\n  font-size: 0.95rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.stat-value {\n  font-size: 2rem;\n  font-weight: bold;\n  margin: 0;\n}\n\n/* Sale Form - Uses glass-panel from design-system.css */\n.sale-form {\n  /* Inherits from .glass-panel via class in JSX */\n  padding: 25px;\n  margin-bottom: 30px;\n}\n\n.sale-form h2 {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: #ffffff;\n  font-weight: 500;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 10px 15px;\n  background: rgba(15, 23, 42, 0.6);\n  color: var(--white);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 5px;\n  font-size: 1rem;\n  transition: border-color 0.3s;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n/* Sales Table - Uses glass-panel from design-system.css */\n.sales-table-container {\n  /* Inherits from .glass-panel via class in JSX */\n  overflow: hidden;\n}\n\n.sales-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.sales-table thead {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.sales-table th {\n  padding: 15px;\n  text-align: left;\n  font-weight: 600;\n}\n\n.sales-table tbody tr {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  transition: background-color 0.3s;\n}\n\n.sales-table tbody tr:hover {\n  background-color: rgba(99, 102, 241, 0.1);\n}\n\n.sales-table td {\n  padding: 15px;\n  color: #ffffff;\n}\n\n.sales-table .amount {\n  font-weight: 600;\n  color: #818cf8;\n  font-size: 1.1rem;\n}\n\n.sales-table .actions {\n  display: flex;\n  gap: 10px;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 40px;\n  color: #ffffff;\n  font-style: italic;\n}\n\n/* Buttons */\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn-success {\n  background: #10b981;\n  color: white;\n}\n\n.btn-success:hover {\n  background: #059669;\n}\n\n.btn-secondary {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.btn-icon {\n  padding: 8px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  background: transparent;\n  transition: all 0.3s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.btn-icon.edit {\n  color: #f59e0b;\n}\n\n.btn-icon.edit:hover {\n  background: rgba(245, 158, 11, 0.15);\n  transform: scale(1.1);\n}\n\n.btn-icon.delete {\n  color: #ef4444;\n}\n\n.btn-icon.delete:hover {\n  background: rgba(239, 68, 68, 0.15);\n  transform: scale(1.1);\n}\n\n/* Loading */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border: 5px solid #f3f3f3;\n  border-top: 5px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .sales-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .page-header {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n  }\n\n  .sales-table {\n    font-size: 0.9rem;\n  }\n\n  .sales-table th,\n  .sales-table td {\n    padding: 10px;\n  }\n}\n\n/* Payment Type Selector */\n.payment-type-selector {\n  display: flex;\n  gap: 20px;\n  margin-top: 10px;\n}\n\n.radio-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 15px;\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s;\n  color: #ffffff;\n}\n\n.radio-label:hover {\n  border-color: #818cf8;\n  background-color: rgba(99, 102, 241, 0.1);\n}\n\n.radio-label input[type='radio'] {\n  margin: 0;\n}\n\n.radio-label input[type='radio']:checked + span {\n  font-weight: 600;\n  color: #818cf8;\n}\n\n.radio-label:has(input:checked) {\n  border-color: #818cf8;\n  background-color: rgba(99, 102, 241, 0.2);\n}\n\n.payment-type {\n  text-align: center;\n  font-size: 1.2rem;\n}\n\n/* Month Selector - Uses glass-panel */\n.month-selector-container {\n  /* Inherits from .glass-panel via class in JSX */\n  margin-bottom: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.month-selector-container label {\n  font-weight: 600;\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 1rem;\n}\n\n.month-selector {\n  flex: 1;\n  max-width: 300px;\n  padding: 12px 15px;\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  font-size: 1rem;\n  background: rgba(15, 23, 42, 0.6);\n  cursor: pointer;\n  transition: all 0.3s;\n  color: var(--white);\n  font-weight: 500;\n}\n\n.month-selector:hover {\n  border-color: var(--primary-color);\n  background-color: rgba(99, 102, 241, 0.1);\n}\n\n.month-selector:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\n}\n\n/* Highlighted Stat Card */\n.stat-card.highlight {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: 3px solid #667eea;\n}\n\n.stat-card.highlight h3 {\n  color: rgba(255, 255, 255, 0.9);\n  font-weight: 600;\n}\n\n.stat-card.highlight .stat-value {\n  color: white;\n  font-size: 2.5rem;\n}\n\n.stat-card.highlight small {\n  color: rgba(255, 255, 255, 0.8);\n  display: block;\n  margin-top: 8px;\n  font-size: 0.9rem;\n}\n\n.stat-card small {\n  display: block;\n  margin-top: 8px;\n  color: rgba(226, 232, 240, 0.75);\n  font-size: 0.85rem;\n}\n\n/* ============ LIGHT THEME OVERRIDES ============ */\n[data-theme=\"light\"] .form-group label {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .form-group input {\n  background: rgba(255, 255, 255, 0.9);\n  color: #1e293b;\n  border: 1px solid rgba(15, 23, 42, 0.15);\n}\n\n[data-theme=\"light\"] .form-group input:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);\n}\n\n[data-theme=\"light\"] .sales-table tbody tr {\n  border-bottom: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .sales-table tbody tr:hover {\n  background-color: rgba(100, 116, 139, 0.08);\n}\n\n[data-theme=\"light\"] .sales-table td {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .sales-table .amount {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .empty-state {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .btn-secondary {\n  background: rgba(100, 116, 139, 0.08);\n  color: #1e293b;\n  border: 1px solid rgba(100, 116, 139, 0.2);\n}\n\n[data-theme=\"light\"] .btn-secondary:hover {\n  background: rgba(100, 116, 139, 0.12);\n  border-color: rgba(100, 116, 139, 0.3);\n}\n\n[data-theme=\"light\"] .radio-label {\n  border: 2px solid rgba(15, 23, 42, 0.15);\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .radio-label:hover {\n  border-color: #64748b;\n  background-color: rgba(100, 116, 139, 0.08);\n}\n\n[data-theme=\"light\"] .radio-label input[type='radio']:checked + span {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .radio-label:has(input:checked) {\n  border-color: #64748b;\n  background-color: rgba(100, 116, 139, 0.15);\n}\n\n[data-theme=\"light\"] .month-selector-container label {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .month-selector {\n  border: 2px solid rgba(15, 23, 42, 0.15);\n  background: rgba(255, 255, 255, 0.9);\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .month-selector:hover {\n  border-color: var(--primary-color);\n  background-color: rgba(100, 116, 139, 0.08);\n}\n\n[data-theme=\"light\"] .month-selector:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);\n}\n\n[data-theme=\"light\"] .stat-card small {\n  color: #64748b;\n}\n\n[data-theme=\"light\"] .stat-card h3 {\n  color: #475569;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
